import type { ReactNode } from 'react';
import { useState } from 'react';

import type { RestrictedAccessReason } from './index.ts';
import { RestrictedAccessContext } from './index.ts';

type Props = {
  children: ReactNode;
};
export const RestrictedAccessProvider = ({ children }: Props) => {
  const [showRestrictedAccess, setShowRestrictedAccess] =
    useState<RestrictedAccessReason>();

  return (
    <RestrictedAccessContext
      value={{
        showRestrictedAccess,
        setShowRestrictedAccess,
      }}
    >
      {children}
    </RestrictedAccessContext>
  );
};
